import React, { useState, useEffect } from "react";
import { logo } from "../Assets";

export const menuItems = [
  { id: 1, label: "Home", link: "/" },
  { id: 2, label: "About", link: "../#about" },
  { id: 3, label: "Team", link: "../#team" },
  { id: 4, label: "Roadmap", link: "../#roadmap" },
];

const Navbar = () => {
  const [scrolling, setScrolling] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("Home");

  // Smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  // Track scroll position to highlight active link
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      const sectionOffsets = {
        Home: 0,
        About: document.getElementById("about")?.offsetTop || 0,
        Team: document.getElementById("team")?.offsetTop || 0,
        Roadmap: document.getElementById("roadmap")?.offsetTop || 0,
      };

      const current = Object.keys(sectionOffsets).findLast((key) =>
        scrollPosition >= sectionOffsets[key] - 100
      );

      if (current) setActiveSection(current);

      setScrolling(scrollPosition > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`w-full fixed z-20 top-0 left-0 transition-all duration-300 ${
        scrolling ? "bg-[#14ADFA]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="text-2xl text-white">
            <img src={logo} alt="Logo" className="w-60" />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.id}
                href={item.link}
                className={`transition ${
                  activeSection === item.label ? "text-[#313131]" : "text-white"
                } hover:text-[#313131]`}
              >
                {item.label}
              </a>
            ))}
            <button className="px-6 py-2 text-sm rounded-lg bg-[#FFC300] text-[#313131] hover:bg-[#313131] hover:text-white transition">
              <a href="https://discord.gg/hUMBpwXxTq" target="_blank" >
              Join The Community

              </a>
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-[#14ADFA] text-white flex flex-col items-center space-y-4 py-4">
            {menuItems.map((item) => (
              <a
                key={item.id}
                href={item.link}
                className={`transition ${
                  activeSection === item.label ? "text-[#313131]" : "text-white"
                } hover:text-[#313131]`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <button className="px-6 py-2 text-sm rounded-lg bg-[#FFC300] text-[#313131] hover:bg-[#313131] hover:text-white transition" >
            <a href="https://discord.gg/hUMBpwXxTq" target="_blank" >
              Join The Community

              </a>
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;